
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.508 4.602a3.257 3.257 0 00.508-1.774c0-.588-.196-1.18-.586-1.773.896.38 1.343.979 1.343 1.797 0 .828-.421 1.411-1.265 1.75zM2.75.766V9h-.336c-.13 0-.336.016-.617.047-.24.031-.521.047-.844.047v-.14c.333-.037.61-.201.828-.493.219-.292.328-.854.328-1.688V2.758C2.11 1.622 1.724.974.953.812v-.14c.333.036.932.068 1.797.094zm1.219 2.148V4.61c.307.079.64.118 1 .118 1.172 0 1.758-.61 1.758-1.829 0-1.14-.581-1.71-1.743-1.71-.375 0-.666.075-.875.226-.093.208-.14.708-.14 1.5zM3.547 9H3.32V.766c.313 0 .646-.013 1-.04.407-.036.737-.054.992-.054.714 0 1.245.219 1.594.656.35.432.524.966.524 1.602 0 1.078-.456 1.768-1.367 2.07.453.063.833.198 1.14.406.328.224.826.672 1.492 1.344 1.016 1.031 1.844 1.547 2.485 1.547.13 0 .263-.044.398-.133l.031.14c-.208.272-.497.407-.867.407-.396 0-.81-.149-1.242-.445-.406-.282-1.013-.834-1.82-1.657-.97-1-1.912-1.5-2.828-1.5.567.177 1.335.774 2.304 1.79.683.708 1.23 1.223 1.64 1.546.418.323.816.485 1.196.485V9a1.566 1.566 0 01-.523.094c-.505 0-.943-.128-1.313-.383a7.916 7.916 0 01-.758-.64 30.588 30.588 0 01-1.093-1.126c-.625-.666-1.089-1.12-1.39-1.36a3.218 3.218 0 00-.946-.515v1.852c0 1.245.375 1.922 1.125 2.031v.14A16.108 16.108 0 003.547 9z","fill":"currentColor"}})])
          )
        }
      }
    